module.exports = __webpack_public_path__ + "static/media/plus.fa51524f.svg";